import axios, { type AxiosError } from 'axios'

import store, { type RootGetters } from './store'

let isHandling401 = false

axios.interceptors.response.use(
  async function (response) {
    const fe_version: string =
      (response.headers as Record<string, string | undefined>)['fe-version'] ??
      'default'
    const storedVersion = localStorage.getItem('fe-version')
    if (fe_version !== storedVersion && response.config.method === 'get') {
      localStorage.setItem('fe-version', fe_version)
      if (storedVersion != null) {
        window.location.reload()
      }
    }
    return Promise.resolve(response)
  },
  async function (error: AxiosError) {
    if (error.response?.status === 401 && !isHandling401) {
      isHandling401 = true
      const isSessionEndpoint = error.config.url?.startsWith('/api/session')
      const wasConnected = store.state.session.key != null

      store.commit('RESET_LOGIN_ON_401')

      if (wasConnected) {
        const { default: router } = await import('./router')
        store.commit('SET_REDIRECT_AFTER_LOGIN', router.currentRoute.path)
        await router.replace('/login').catch(() => {
          /* already on login */
        })
      } else if (isSessionEndpoint === false) {
        window.location.reload()
      }
      // Delay reset to cover concurrent 401 responses from parallel requests.
      // setTimeout(0) was too short: it resets between macrotasks, allowing a
      // second 401 to see wasConnected=false and trigger an unwanted reload.
      setTimeout(() => {
        isHandling401 = false
      }, 2000)
    }
    return Promise.reject(error)
  },
)

axios.interceptors.request.use(async function (config) {
  const isMutationMethod = ['post', 'put', 'patch', 'delete'].includes(
    config.method ?? '',
  )
  const isExcludedPath = [
    '/api/applicationConfig/markDirty',
    '/api/analytics',
    '/api/users',
    '/api/sessions',
    '/api/notif',
  ].some((path) => config.url?.startsWith(path))

  if (
    isMutationMethod &&
    !isExcludedPath &&
    // FIXME weird bug "can't access lexical variable 'appConfig' before initialization"
    // useAppConfigGetter("isDirty").value &&
    !(store.getters as RootGetters).isDirty
  ) {
    // FIXME idem
    // await dispatchAppConfig("MARK_DIRTY");
    await store.dispatch('MARK_DIRTY')
  }
  return config
})
